import createClient from 'openapi-fetch';
import { localizedFetch } from '@/lib/apiClient';
import { getPersianErrorMessage } from '@/lib/persianUi';

const client = createClient({
    baseUrl: '/api/v1',
    credentials: 'include',
    fetch: localizedFetch,
});

export async function listConfigs() {
    const { data, error } = await client.GET('/vendor/referral/configs');
    if (error) throw new Error(getPersianErrorMessage(error, 'خطا در دریافت برنامه‌ها.'));
    return data || [];
}

export async function updateConfig(id, payload) {
    const { data, error } = await client.PUT('/vendor/referral/configs/{config_id}', {
        params: { path: { config_id: id } },
        body: payload
    });
    if (error) throw new Error(getPersianErrorMessage(error, 'خطا در ویرایش برنامه.'));
    return data;
}

export async function activateConfig(id) {
    const { data, error } = await client.PATCH('/vendor/referral/configs/{config_id}/activate', {
        params: { path: { config_id: id } }
    });
    if (error) throw new Error(getPersianErrorMessage(error, 'خطا در فعال‌سازی برنامه.'));
    return data;
}

export async function deleteConfig(id) {
    const { error } = await client.DELETE('/vendor/referral/configs/{config_id}', {
        params: { path: { config_id: id } }
    });
    if (error) throw new Error(getPersianErrorMessage(error, 'خطا در حذف برنامه.'));
}